import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Output,
} from '@angular/core';
import intlTelInput from 'intl-tel-input';

@Directive({
  selector: '[appIntlTelInput]',
  standalone: true,
})
export class IntlTelInputDirective implements AfterViewInit {
  @Output() phoneChange = new EventEmitter<string>();
  iti: any;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngAfterViewInit(): void {
    this.iti = intlTelInput(this.el.nativeElement, {
      separateDialCode: true,
      initialCountry: 'it',
      strictMode: true,
      dropdownContainer: document.body,
    });

    this.el.nativeElement.addEventListener('countrychange', () => {
      this.phoneChange.emit(this.el.nativeElement.value);
    });
  }
}
